import {faCheck} from '@fortawesome/pro-regular-svg-icons';
import {ItemIndicator, CheckboxItem} from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {DropdownMenuCheckboxItemProps} from '@radix-ui/react-dropdown-menu';

export function DropdownCheckboxItem({
  ref: forwardedRef,
  children,
  className,
  ...props
}: DropdownMenuCheckboxItemProps &
  React.RefAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <CheckboxItem
      {...props}
      ref={forwardedRef}
      className={clsx(
        className,
        'group relative cursor-pointer py-1 pl-6 pr-2 text-sm radix-disabled:cursor-default radix-disabled:text-slate10 radix-highlighted:bg-blue10 radix-highlighted:font-semibold radix-highlighted:text-white radix-highlighted:outline-hidden radix-state-checked:font-semibold'
      )}
    >
      <ItemIndicator className="absolute left-2 top-1/2 -translate-y-1/2 text-blue11 group-radix-highlighted:text-white">
        <Icon size="sm" icon={faCheck} />
      </ItemIndicator>

      {children}
    </CheckboxItem>
  );
}

DropdownCheckboxItem.displayName = 'DropdownCheckboxItem';
